if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-cart') && document.querySelector('.cart-subtotal') != null){
  const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
  const apConfig = {
    priceSelector: '.cart-policies',
    locale: 'en_US',
    currency: 'USD',
    afterpayLogoColor: 'white',
    showUpperLimit: false,
    amount: cartTotal,
    minMaxThreshold: {
      min: 100,
      max: 100000,
    },
  };
  new presentAfterpay(apConfig).init();
  /* removing $ FP start 04-04-2025 */
/*  if(getCookie("remove_price_icon") == "true"){
    let afterPay = document.querySelector('.checkout-subtotal-container').querySelector('.afterpay-text1').textContent;
    if(afterPay.indexOf('$')){
      afterPay = afterPay.replace('$', '')
      document.querySelector('.checkout-subtotal-container').querySelector('.afterpay-text1').textContent = afterPay;
    }
  }*/
  /* removing $ FP end 04-04-2025 */
}
window.onload = function() {
  if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-product')){
    if(window.innerWidth > 768) {
      const ap = new presentAfterpay(apConfig).init();
    }
    apConfig.priceSelector = '.main-mobile-price-selector';
    new presentAfterpay(apConfig).init();
    var price = document.querySelector('product-form.sticky-content-container .price');
    var config = {childList: true, subtree: true };
    /* removing $ FP start 04-04-2025 */
    /*if(getCookie("remove_price_icon") == "true"){
      setTimeout(function(){
        let afterPay = document.querySelector('.js-product .product-form .main-price-selector+.afterpay-paragraph .afterpay-text1').textContent;
        if(afterPay.indexOf('$')){
          afterPay = afterPay.replace('$', '')
          document.querySelector('.js-product .product-form .main-price-selector+.afterpay-paragraph .afterpay-text1').textContent = afterPay;
        }
      }, 1500);
    }*/
    /* removing $ FP end 04-04-2025 */
  }  
  var intervalStampedInstagram = setInterval(function(){
    if(document.querySelector('body').classList.contains('template-product')){
      if(document.querySelector('.stamped-instagram-media-block-template') != null){
        if(document.querySelectorAll('.stamped-instagram-media-block').length < 2){
          document.querySelector('.hometitle.app_title').classList.add('hidden');
        }else{
          document.querySelector('.hometitle.app_title').classList.remove('hidden');
        }
        clearInterval(intervalStampedInstagram);
      }
    }
  },3000);

}
$(document).ready(function(){
  const customSlider = document.querySelector('.custom-slider-block');
  if(customSlider != null){
    const customSliderConf = document.querySelector('.slider-config').textContent;
    const configuration = JSON.parse(customSliderConf);
    if($('.custom-slider-block').hasClass('slick-slider')){
      $('.custom-slider-block').slick(configuration);
    }else{
      $('.custom-slider-block').owlCarousel(configuration);
    }
  }

    /* lux rave slider on mobile AP 19-03-2025 */
  if ($(window).width() < 480) {
    $('.meet-greet-rows').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: false,        
        centerPadding: '80px',
        infinite: true,
        
     });
  }
  /* lux rave slider on mobile AP 19-03-2025 */
  
});

/*Lux rav landing page sluder */
$( document ).ready(function() {
    $('.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
      dots:false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
})
}); 
/*Lux rav landing page sluder */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.rte a[aria-label]').forEach(link => {
    const visibleText = link.textContent.trim();
    const aria = link.getAttribute('aria-label');
    if (aria && !aria.includes(visibleText)) {
      link.setAttribute('aria-label', `${visibleText} - ${aria}`);
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutationsList) {
    const img = document.querySelector('pdqproductpromise .pdq-pdp__widget-icon');
    if (img && !img.hasAttribute('alt')) {
      img.setAttribute('alt', 'shipping track icon');
      observer.disconnect(); // Stop observing after it's set
    }
  });

  // Observe the body for dynamic loading of pdqproductpromise
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
document.querySelectorAll('.rte a:not([href])').forEach(function (a) {
    // Only add role and tabindex if not already present
    if (!a.hasAttribute('role')) {
      a.setAttribute('role', 'button');
    }
    if (!a.hasAttribute('tabindex')) {
      a.setAttribute('tabindex', '0');
    }
  });


    document.querySelectorAll('img.gifimg').forEach(img => {
   setTimeout(() => {
      const gifUrl = img.dataset.gif 
      img.src = gifUrl;
    }, 5000); 

 }); 
 // let iframeCount = 0;

// const instaObserver = new MutationObserver((mutationsList) => {
//   mutationsList.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (node.tagName === 'iframe' && node.src.includes('instagram.com')) {
//         // Generate a unique ID
//         console.log('dsr');
//         iframeCount++;
//         const iframeId = `instagram-embed-${iframeCount}`;
//         node.setAttribute('id', iframeId);

//         // Find the related blockquote (assumes iframe is added right after it)
//         let parent = node.closest('.instagram-media');
//         if (!parent) {
//           const prev = node.previousElementSibling;
//           if (prev?.classList?.contains('instagram-media')) {
//             parent = prev;
//           }
//         }

//         // Get custom title or fallback
//         const baseTitle = parent?.getAttribute('data-title') || 'Instagram post';

//         // Set title with format: "base title - iframe-id"
//         node.setAttribute('title', `${baseTitle} - ${iframeId}`);
//       }
//     });
//   });
// });

// instaObserver.observe(document.body, {
//   childList: true,
//   subtree: true
// });


  
});
/*


 function isGifFile(url) {
  if (typeof url !== 'string' || url.length === 0) return false;
  const cleanUrl = url.split('?')[0];
  const segments = cleanUrl.split('/');
  const filename = segments[segments.length - 1];
  const parts = filename.split('.');
  const extension = parts[parts.length - 1];
  return extension.toLowerCase() === 'gif';
}

  document.addEventListener("DOMContentLoaded", function () {
    let gifCounter = 0;
  document.querySelectorAll('.product-block__image .img-ar img.theme-img , .product-media--image .img-ar img.theme-img ,  .product-media--image .img-ar img.zoomImg , carousel-slider.thumbnails .thumbnail  img.theme-img ').forEach(function (img) {    
    const src = img.getAttribute('src');

    if (isGifFile(src)) {
      const gifSrc = src;
      const [baseUrl, queryString] = gifSrc.split('?');
      const jpgBaseUrl = baseUrl.replace(/\.gif$/i, '.jpg');
      const placeholderSrc = queryString ? `${jpgBaseUrl}?${queryString}` : jpgBaseUrl;

      const wrapper = document.createElement('div');
      const uniqueClass = `gif-wrapper-${gifCounter++}`;
      wrapper.className = `gif-wrapper ${uniqueClass}`;
      wrapper.dataset.wrapperId = uniqueClass;
      //wrapper.className = 'gif-wrapper';

      // Create image (initially static JPG)
      const newImg = img.cloneNode();
      newImg.src = placeholderSrc;
      newImg.dataset.gifSrc = gifSrc;
      newImg.dataset.placeholder = placeholderSrc;
      newImg.classList.add('gif-placeholder');

      // Handle srcset: store both versions
      if (img.hasAttribute('srcset')) {
        const originalSrcset = img.getAttribute('srcset'); // GIF version
        newImg.dataset.originalSrcset = originalSrcset;

        const jpgSrcset = originalSrcset
          .split(',')
          .map(item => {
            const [urlPart, size] = item.trim().split(' ');
            const [urlBase, urlQuery] = urlPart.split('?');
            const jpgUrlBase = urlBase.replace(/\.gif$/i, '.jpg');
            const newUrl = urlQuery ? `${jpgUrlBase}?${urlQuery}` : jpgUrlBase;
            return `${newUrl} ${size}`;
          })
          .join(', ');
        newImg.setAttribute('srcset', jpgSrcset);
        newImg.dataset.jpgSrcset = jpgSrcset;
      }

      // Create toggle button with play/pause icons
      const button = document.createElement('button');
      button.className = 'gif-toggle-btn';
      button.setAttribute('aria-label', 'Toggle animation');

      button.innerHTML = `
        <i class="play" >
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <circle style="fill-opacity:0.1; stroke:#FFFFFF;stroke-width:2;" cx="20" cy="20" r="18.8"></circle>
            <path style="stroke:#FFFFFF;stroke-width:2;" fill="none"
                  d="M29.8,19.9l-14.3,7.9c-0.3,0.2-0.7-0.1-0.7-0.4V11.6c0-0.4,0.4-0.6,0.7-0.4l14.3,7.9C30.1,19.3,30.1,19.8,29.8,19.9z"/>
          </svg>
        </i>
        <i class="pause" style="display: none;">
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <circle style="fill-opacity:0.1; stroke:#FFFFFF;stroke-width:2" cx="20" cy="20" r="18.9"></circle>
            <line style="stroke:#FFFFFF;stroke-width:2;" fill="none" x1="15.6" y1="11.3" x2="15.6" y2="28.7"></line>
            <line style="stroke:#FFFFFF;stroke-width:2;" fill="none" x1="24.4" y1="11.3" x2="24.4" y2="28.7"></line>
          </svg>
        </i>
      `;

      let playing = false;

      button.addEventListener('click', function (e) { 
        e.preventDefault();
        playing = !playing;
const wrapper = this.closest('.gif-wrapper');  
  const newImg = wrapper.querySelector('img.gif-placeholder');
        // Toggle image src
        newImg.src = playing ? gifSrc : placeholderSrc;

        // Toggle srcset
        if (newImg.hasAttribute('data-original-srcset')) {
          const original = newImg.dataset.originalSrcset;
          const jpgSrcset = original
            .split(',')
            .map(item => {
              const [urlPart, size] = item.trim().split(' ');
              const [urlBase, urlQuery] = urlPart.split('?');
              const jpgUrlBase = urlBase.replace(/\.gif$/i, '.jpg');
              const newUrl = urlQuery ? `${jpgUrlBase}?${urlQuery}` : jpgUrlBase;
              return `${newUrl} ${size}`;
            })
            .join(', ');
          newImg.setAttribute('srcset', playing ? original : jpgSrcset);
        }

        // Toggle icons
        button.querySelector('.play ').style.display = playing ? 'none' : '';
        button.querySelector('.pause').style.display = playing ? '' : 'none';
      });

      const parent = img.parentNode;
      if (parent) {
        parent.replaceChild(wrapper, img);
        wrapper.appendChild(newImg);
        wrapper.appendChild(button);
      }
    }
  });
});
*/



